import type { BlockExport } from "@/react/components/shared/BuilderUI/BuilderUI.types";
import { FormParagraphBlock as Block } from "./FormParagraphBlock";
import { defaultData } from "./FormParagraphBlockDefaultData";
import { meta } from "./FormParagraphBlockMetaData";

export const FormParagraphBlock: BlockExport = {
  type: "component",
  Block,
  defaultData,
  imagePreview: {
    type: "icon",
    name: "24-builder-ui-element-paragraph",
    size: 24,
  },
  meta,
};
